const isStringNumber = (value) => !isNaN(Number(value));
class UtilEnum {
    static enumToArray(enums) {
        return Object.keys(enums).filter(isStringNumber).map((key) => enums[key]);
    }
}
export default UtilEnum;
